<template>
  <div class="container profile">
    <div class="flex flex-wrap justify-content-center profile-header gap-2 pt-4">
      <div class="flex flex-wrap justify-content-center">
        <img :src="user?.picture" alt="User's profile picture" class="border-circle img-fluid profile-picture" />
      </div>
      <div class="">
        <h2>{{ user?.name }}</h2>
        <p class="lead text-muted">Email: {{ user?.email }}</p>
        <p class="lead text-muted">Store name: {{ storename }}</p> 
        <p class="lead text-muted">User role: {{ role }}</p> 
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useAuth0 } from '@auth0/auth0-vue';
import { ref } from "@vue/reactivity";
import { onBeforeMount } from 'vue';
import { useStore } from 'vuex';

const storeid = ref('');
const storename = ref('');
const role = ref('');
const { user } = useAuth0();
const store = useStore();

onBeforeMount(() => {
  storeid.value = store.state.storeid;
  storename.value = store.state.storename;
  role.value = store.state.role;
});
</script>
